const $ = require("../utils/fetch");

export function createDepartment(name, parent) {
  const params = {
    name: name,
    parent: parent,
  };

  return $.put("/department", params);
}

export function getParentDepartmentList(departmentId) {
  const params = {
    departmentId: JSON.stringify(departmentId),
  };
  return $.get("/department/ids", params);
}

export function getChildrenDepartments(name, parent, level) {
  const params = {
    name: name,
    parent: JSON.stringify(parent),
    level: JSON.stringify(level),
  };
  name == "" ? delete params.name : "";
  parent.length == 0 ? delete params.parent : "";
  level.length == 0 ? delete params.level : "";

  return $.get("/department/list", params);
}

export function getDepartmentCount(name, parent, level) {
  const params = {
    name: name,
    parent: JSON.stringify(parent),
    level: JSON.stringify(level),
  };
  name == "" ? delete params.name : "";
  // parent.length==0 ? (delete params.parent) : '';
  level.length == 0 ? delete params.level : "";

  return $.get("/department/count", params);
}

export function updateDepartment(departmentId, name) {
  const params = {
    name: name,
  };

  return $.post("/department/" + departmentId, params);
}

export function transferDepartment(departmentId, targetDepartment, password) {
  const params = {
    targetDepartment: targetDepartment,
    // password: password
  };
  return $.post("/department/move/" + departmentId, params);
}

export function deleteDepartment(departmentId, targetDepartment, password) {
  const params = {
    targetDepartment: targetDepartment,
    // password: password
  };
  return $.toDelete("/department/" + departmentId, params);
}

export function getDepartmentTrees(departmentId) {
  const params = {
    departmentId: JSON.stringify(departmentId),
  };
  departmentId.length == 0 ? delete params.departmentId : "";

  return $.get("/department/child", params);
}



// WEBPACK FOOTER //
// ./src/api/department.js